export const regularServicesData = [
  {
    id: 1,
    serviceName: "Oil Change",
    durationMin: 30,
    durationMax: 60,
    priceMin: 35,
    priceMax: 75,
    description: "Replacement of engine oil and oil filter to ensure proper lubrication and engine health.",
    signsYouNeedService: [
      "Vehicle maintenance schedule recommends it",
      "Low oil level warning light is on",
      "Oil appears dark or dirty",
      "Engine noise or knocking"
    ],
    whatWeOffer: [
      "Draining old oil",
      "Replacing oil filter",
      "Refilling with specified oil type and amount",
      "Lubrication of key components",
      "Basic check of other fluid levels"
    ]
  },
  {
    id: 2,
    serviceName: "Tire Rotation",
    durationMin: 20,
    durationMax: 45,
    priceMin: 25,
    priceMax: 50,
    description: "Moving tires from one position to another to ensure even wear and prolong their lifespan.",
    signsYouNeedService: [
      "Uneven tire wear patterns",
      "Vehicle pulling to one side",
      "Recommended by vehicle manufacturer",
      "After significant mileage (e.g., every 5,000-7,500 miles)"
    ],
    whatWeOffer: [
      "Careful removal of all four tires",
      "Inspection of tire tread depth and condition",
      "Strategic placement of tires to promote even wear",
      "Reinstallation and proper inflation",
      "Torquing of lug nuts to specification"
    ]
  },
  {
    id: 3,
    serviceName: "Multi-Point Inspection",
    durationMin: 30,
    durationMax: 60,
    priceMin: 0,
    priceMax: 50,
    description: "A comprehensive visual inspection of your vehicle's key components to identify potential issues before they become major problems.",
    signsYouNeedService: [
      "Routine maintenance check",
      "Before a long road trip",
      "When purchasing a used vehicle",
      "If you notice unusual noises or performance changes"
    ],
    whatWeOffer: [
      "Inspection of brakes (pads, rotors, lines)",
      "Check of tires (pressure, tread, wear)",
      "Examination of suspension and steering components",
      "Verification of fluid levels (coolant, brake fluid, power steering, etc.)",
      "Inspection of belts and hoses",
      "Check of lights and wipers",
      "Visual inspection of exhaust system"
    ]
  },
  {
    id: 4,
    serviceName: "Tire Replacement",
    durationMin: 60,
    durationMax: 120,
    priceMin: 100,
    priceMax: 300,
    description: "Removal of old tires and installation of new tires to ensure safety, performance, and proper handling.",
    signsYouNeedService: [
      "Tread is worn below the legal limit",
      "Visible cracks, bulges, or cuts in the tire sidewall",
      "Frequent tire pressure loss",
      "Poor traction or hydroplaning"
    ],
    whatWeOffer: [
      "Selection of appropriate new tires",
      "Professional mounting and balancing of tires",
      "Disposal of old tires",
      "Inflation to manufacturer-recommended pressure",
      "Wheel alignment check (recommended after replacement)"
    ]
  },
  {
    id: 5,
    serviceName: "Wheel Alignment",
    durationMin: 60,
    durationMax: 120,
    priceMin: 75,
    priceMax: 150,
    description: "Adjustment of the angles of your vehicle's wheels to the specifications recommended by the manufacturer, ensuring proper tire wear and handling.",
    signsYouNeedService: [
      "Uneven tire wear",
      "Vehicle pulls to one side",
      "Steering wheel is off-center when driving straight",
      "After hitting a pothole or curb",
      "After replacing suspension components"
    ],
    whatWeOffer: [
      "Precise measurement of wheel angles (camber, caster, toe)",
      "Adjustment to manufacturer specifications",
      "Use of advanced alignment equipment",
      "Ensuring optimal tire life and vehicle stability"
    ]
  },
  {
    id: 6,
    serviceName: "Tire Balancing",
    durationMin: 30,
    durationMax: 60,
    priceMin: 40,
    priceMax: 80,
    description: "Adding small weights to balance the tire and wheel assembly, ensuring a smooth ride and preventing premature tire wear.",
    signsYouNeedService: [
      "Vibrations in the steering wheel or seat at certain speeds",
      "Uneven tire wear",
      "After installing new tires",
      "If you notice a rougher ride than usual"
    ],
    whatWeOffer: [
      "Dismounting tire from wheel (if necessary)",
      "Spin balancing of the tire and wheel assembly",
      "Application of counterweights to correct imbalances",
      "Reinstallation and proper inflation"
    ]
  },
  {
    id: 7,
    serviceName: "Brake Pad Replacement",
    durationMin: 60,
    durationMax: 120,
    priceMin: 150,
    priceMax: 350,
    description: "Replacing worn brake pads with new ones to restore optimal braking performance and safety.",
    signsYouNeedService: [
      "Squealing or grinding noises when braking",
      "Reduced braking responsiveness",
      "Brake pedal feels spongy or goes too low",
      "Brake warning light is illuminated"
    ],
    whatWeOffer: [
      "Inspection of brake pads and rotors",
      "Removal of old brake pads",
      "Installation of new, high-quality brake pads",
      "Lubrication of caliper pins and hardware",
      "Brake system check"
    ]
  },
  {
    id: 8,
    serviceName: "Brake Rotor Replacement",
    durationMin: 90,
    durationMax: 180,
    priceMin: 200,
    priceMax: 500,
    description: "Replacing worn or damaged brake rotors to ensure consistent and effective braking.",
    signsYouNeedService: [
      "Grooved or warped rotors",
      "Brake pulsation or vibration when braking",
      "Deep scoring or rust on rotor surface",
      "When brake pads are replaced and rotors are below minimum thickness"
    ],
    whatWeOffer: [
      "Inspection of brake rotors for wear and damage",
      "Removal of old rotors",
      "Installation of new, precision-machined rotors",
      "Ensuring proper mating with new brake pads",
      "Brake system flush (recommended)"
    ]
  },
  {
    id: 9,
    serviceName: "Brake Fluid Flush",
    durationMin: 45,
    durationMax: 60,
    priceMin: 80,
    priceMax: 150,
    description: "Replacing old, contaminated brake fluid with new fluid to maintain optimal hydraulic pressure and prevent corrosion in the brake system.",
    signsYouNeedService: [
      "Brake fluid appears dark or discolored",
      "Brake pedal feels spongy",
      "Recommended by vehicle manufacturer (typically every 2-3 years)",
      "After replacing brake components"
    ],
    whatWeOffer: [
      "Draining of old brake fluid",
      "Flushing of the brake system to remove contaminants",
      "Refilling with fresh, high-quality brake fluid",
      "Bleeding the brake system to remove air bubbles",
      "Inspection of brake lines and components"
    ]
  },
  {
    id: 10,
    serviceName: "Engine Diagnostics",
    durationMin: 30,
    durationMax: 90,
    priceMin: 75,
    priceMax: 150,
    description: "Using specialized tools and techniques to identify the root cause of engine performance issues or warning lights.",
    signsYouNeedService: [
      "Check Engine light is on",
      "Unusual engine noises",
      "Rough idling or stalling",
      "Decreased fuel economy",
      "Engine performance issues (hesitation, lack of power)"
    ],
    whatWeOffer: [
      "Scanning vehicle's computer for error codes",
      "Live data analysis from sensors",
      "Visual inspection of engine components",
      "Testing of specific systems (fuel, ignition, emissions)",
      "Accurate diagnosis of problems"
    ]
  },
  {
    id: 11,
    serviceName: "Spark Plug Replacement",
    durationMin: 60,
    durationMax: 120,
    priceMin: 100,
    priceMax: 250,
    description: "Replacing worn spark plugs to ensure proper ignition, combustion, and engine efficiency.",
    signsYouNeedService: [
      "Rough idling or misfires",
      "Difficulty starting the engine",
      "Reduced acceleration",
      "Increased fuel consumption",
      "Check Engine light illuminated"
    ],
    whatWeOffer: [
      "Inspection of current spark plugs",
      "Removal of old spark plugs",
      "Installation of new, high-quality spark plugs",
      "Ensuring proper gap settings",
      "Coil pack inspection (if applicable)"
    ]
  },
  {
    id: 12,
    serviceName: "Timing Belt Replacement",
    durationMin: 240,
    durationMax: 480,
    priceMin: 500,
    priceMax: 1200,
    description: "Replacing the timing belt, a critical component that synchronizes the engine's valves and pistons, to prevent catastrophic engine damage.",
    signsYouNeedService: [
      "Vehicle reaches recommended mileage interval for replacement (e.g., 60,000-100,000 miles)",
      "Frayed or worn timing belt visible",
      "Ticking noise from the engine",
      "Engine misfires or rough running"
    ],
    whatWeOffer: [
      "Professional replacement of the timing belt",
      "Replacement of associated components like the water pump, tensioners, and idler pulleys",
      "Ensuring precise timing synchronization",
      "Preventing severe engine damage"
    ]
  },
  {
    id: 13,
    serviceName: "Battery Replacement",
    durationMin: 30,
    durationMax: 60,
    priceMin: 100,
    priceMax: 250,
    description: "Installing a new car battery when the old one is no longer holding a charge or is nearing the end of its lifespan.",
    signsYouNeedService: [
      "Slow engine crank or difficulty starting",
      "Dim headlights or interior lights",
      "Battery warning light is on",
      "Battery is old (typically 3-5 years)"
    ],
    whatWeOffer: [
      "Testing of current battery health",
      "Professional installation of a new, appropriate battery",
      "Cleaning of battery terminals",
      "Securing battery in place",
      "Disposal of old battery"
    ]
  },
  {
    id: 14,
    serviceName: "Alternator Replacement",
    durationMin: 120,
    durationMax: 180,
    priceMin: 300,
    priceMax: 600,
    description: "Replacing a faulty alternator to ensure the vehicle's electrical system is properly powered and the battery is recharged.",
    signsYouNeedService: [
      "Battery warning light is on",
      "Dimming headlights or dashboard lights",
      "Electrical components malfunctioning",
      "Strange whining noise from the engine bay",
      "Dead battery after driving"
    ],
    whatWeOffer: [
      "Diagnosis of alternator failure",
      "Removal of old alternator",
      "Installation of a new, quality alternator",
      "Testing of charging system output",
      "Belt inspection"
    ]
  },
  {
    id: 15,
    serviceName: "AC Recharge",
    durationMin: 60,
    durationMax: 120,
    priceMin: 100,
    priceMax: 200,
    description: "Adding refrigerant to the vehicle's air conditioning system to restore cooling performance.",
    signsYouNeedService: [
      "AC system is not blowing cold air",
      "Weak airflow from vents",
      "Unusual noises from the AC system"
    ],
    whatWeOffer: [
      "Inspection for leaks in the AC system",
      "Evacuation of old refrigerant (if necessary)",
      "Recharging the system with the correct type and amount of refrigerant",
      "Testing AC system performance",
      "Leak detection dye added (optional)"
    ]
  },
  {
    id: 16,
    serviceName: "AC Compressor Replacement",
    durationMin: 180,
    durationMax: 240,
    priceMin: 500,
    priceMax: 1000,
    description: "Replacing the AC compressor, the heart of the air conditioning system, when it fails.",
    signsYouNeedService: [
      "No cold air from AC",
      "AC system makes loud noises (grinding, rattling)",
      "Belt slipping on compressor pulley",
      "AC system not engaging"
    ],
    whatWeOffer: [
      "Removal of faulty AC compressor",
      "Installation of a new AC compressor",
      "Replacement of AC system components as needed (e.g., receiver/drier, expansion valve)",
      "Flushing the AC system to remove debris",
      "Recharging the AC system with refrigerant"
    ]
  },
  {
    id: 17,
    serviceName: "Coolant Flush",
    durationMin: 60,
    durationMax: 90,
    priceMin: 100,
    priceMax: 175,
    description: "Draining and replacing the old coolant with fresh coolant to prevent overheating and corrosion in the cooling system.",
    signsYouNeedService: [
      "Coolant appears rusty or dirty",
      "Engine overheating",
      "Recommended by vehicle manufacturer (typically every 30,000-60,000 miles)",
      "After replacing cooling system components"
    ],
    whatWeOffer: [
      "Draining old coolant from the system",
      "Flushing the cooling system to remove sediment and rust",
      "Refilling with the correct type and mixture of antifreeze/coolant",
      "Bleeding the cooling system to remove air pockets",
      "Inspection of hoses and radiator"
    ]
  },
  {
    id: 18,
    serviceName: "Radiator Replacement",
    durationMin: 120,
    durationMax: 240,
    priceMin: 300,
    priceMax: 700,
    description: "Replacing a damaged or malfunctioning radiator to ensure the engine is kept at optimal operating temperature.",
    signsYouNeedService: [
      "Engine overheating",
      "Visible leaks from the radiator",
      "Corroded or damaged radiator fins",
      "Low coolant level despite no visible leaks"
    ],
    whatWeOffer: [
      "Removal of old radiator",
      "Installation of a new, compatible radiator",
      "Connection of hoses and fans",
      "Refilling and bleeding the cooling system",
      "Pressure testing the system"
    ]
  },
  {
    id: 19,
    serviceName: "Transmission Fluid Change",
    durationMin: 90,
    durationMax: 150,
    priceMin: 150,
    priceMax: 300,
    description: "Replacing the transmission fluid and filter to ensure smooth gear shifts and prolong the life of the transmission.",
    signsYouNeedService: [
      "Rough or delayed gear changes",
      "Transmission slipping",
      "Transmission fluid is dark or has a burnt smell",
      "Recommended by vehicle manufacturer (interval varies significantly)"
    ],
    whatWeOffer: [
      "Draining old transmission fluid",
      "Replacing the transmission filter",
      "Refilling with the correct type and amount of transmission fluid",
      "Inspection of transmission for leaks"
    ]
  },
  {
    id: 20,
    serviceName: "Transmission Rebuild",
    durationMin: 480,
    durationMax: 600,
    priceMin: 1500,
    priceMax: 3500,
    description: "A comprehensive repair and overhaul of a worn or damaged transmission to restore its functionality.",
    signsYouNeedService: [
      "Severe transmission problems (e.g., not shifting, grinding gears, slipping)",
      "Major internal transmission damage diagnosed",
      "When repair is more cost-effective than replacement"
    ],
    whatWeOffer: [
      "Complete disassembly of the transmission",
      "Inspection and replacement of worn internal components (clutches, seals, bands)",
      "Cleaning and reassembly of the transmission",
      "Refilling with fresh fluid",
      "Testing of rebuilt transmission"
    ]
  },
  {
    id: 21,
    serviceName: "Shock/Strut Replacement",
    durationMin: 120,
    durationMax: 240,
    priceMin: 300,
    priceMax: 800,
    description: "Replacing worn shocks or struts to improve ride comfort, handling, and stability.",
    signsYouNeedService: [
      "Bouncy or jarring ride",
      "Excessive body roll during cornering",
      "Tires cupping or feathering on the edges",
      "Leaking from shocks or struts",
      "Vehicle nose dives when braking or squats when accelerating"
    ],
    whatWeOffer: [
      "Inspection of shocks and struts for wear and damage",
      "Removal of old shocks/struts",
      "Installation of new, high-quality shocks/struts",
      "Ensuring proper fit and function",
      "Wheel alignment check (recommended)"
    ]
  },
  {
    id: 22,
    serviceName: "Wheel Bearing Replacement",
    durationMin: 90,
    durationMax: 180,
    priceMin: 200,
    priceMax: 500,
    description: "Replacing worn wheel bearings to eliminate noise and ensure smooth rotation of the wheel.",
    signsYouNeedService: [
      "Humming, grinding, or clicking noise that increases with speed",
      "Wobbling or looseness in the wheel",
      "Excessive play in the wheel when pushed/pulled",
      "Uneven tire wear"
    ],
    whatWeOffer: [
      "Diagnosis of faulty wheel bearing",
      "Removal of hub assembly and old bearing",
      "Installation of new wheel bearing and seal",
      "Ensuring proper torque settings",
      "Wheel alignment check (recommended)"
    ]
  },
  {
    id: 23,
    serviceName: "Check Engine Diagnostics",
    durationMin: 30,
    durationMax: 90,
    priceMin: 75,
    priceMax: 150,
    description: "Using advanced diagnostic tools to interpret check engine light codes and pinpoint the source of the issue.",
    signsYouNeedService: [
      "Check Engine light is illuminated",
      "Vehicle is running poorly",
      "Emissions test failure"
    ],
    whatWeOffer: [
      "Connecting diagnostic scanner to vehicle's OBD-II port",
      "Reading and interpreting diagnostic trouble codes (DTCs)",
      "Live data stream analysis",
      "Providing a clear explanation of the problem",
      "Recommending necessary repairs"
    ]
  },
  {
    id: 24,
    serviceName: "Pre-Purchase Inspection",
    durationMin: 60,
    durationMax: 120,
    priceMin: 100,
    priceMax: 200,
    description: "A thorough inspection of a vehicle before purchase to identify any existing or potential mechanical issues.",
    signsYouNeedService: [
      "Considering the purchase of a used vehicle",
      "Wanting peace of mind about the vehicle's condition",
      "Identifying potential hidden problems"
    ],
    whatWeOffer: [
      "Comprehensive visual inspection of the vehicle's exterior, interior, and undercarriage",
      "Inspection of engine, transmission, brakes, suspension, and electrical systems",
      "Test drive to assess performance and identify noises",
      "Detailed report of findings and recommendations",
      "Assistance in negotiating a fair price"
    ]
  }
];

export default regularServicesData;
